<template>
  <div class="text-black tab-content">
    <v-col class="flex-wrap" cols="12">
      <div class="mt-4 mb-3" style="font-size: 32px">
        AI Settings
      </div>
    </v-col>

    <!-- ************ -->
    <!-- prompt begin -->
    <!-- ************ -->
    <v-col class="flex-wrap" cols="12">
      <div class="font-weight-bold">
        AI prompt
        <help-dialog-workflow-ai-prompt
          #default="{ openDialog }"
          :openedFromSettings="true"
          content-class="dialog-top-right"
        >
          <v-icon size="small" class="ml-2" @click="openDialog()"> mdi-help-circle-outline</v-icon>
        </help-dialog-workflow-ai-prompt>
      </div>
    </v-col>
    <v-form ref="formGenerateDiagram" v-model="validForm">
      <v-col class="flex-wrap" cols="12">
        <ai-description-input
          :text="workflow.aiDescription"
          @change-description="debouncedSaveAiDescription($event)"
          label="Describe the business process or the scope of the project in natural language"
          ref="aiDescription"/>
      </v-col>
    </v-form>
    <!-- ********** -->
    <!-- prompt end -->
    <!-- ********** -->

    <v-col class="flex-wrap" cols="12">
      <div class="d-flex align-center justify-space-between">
        <!-- **************** -->
        <!-- AI version begin -->
        <!-- **************** -->
        <div class="my-5">
          <div class="d-flex align-center">
            <ai-version-selector v-model="aiVersion"/>
            <help-dialog-workflow-ai-version content-class="dialog-top-right" />
          </div>
        </div>
        <!-- ************** -->
        <!-- AI version end -->
        <!-- ************** -->
        <!-- <ai-prompt-export #default="{ props }">
          <v-btn rounded="lg" size="large" variant="outlined" density="compact" v-bind="props" class="my-2 mr-4">Export AI
            Prompt
          </v-btn>
        </ai-prompt-export> -->
      </div>
    </v-col>
  </div>
</template>

<script>
import store from '@/store'
import workflowApi from '@/api/workflowApi'
import HelpDialogWorkflowAiPrompt from '@/components/HelpDialogWorkflowAiPrompt'
import HelpDialogWorkflowAiVersion from '@/components/HelpDialogWorkflowAiVersion'
import AiDescriptionInput from '@/components/AiDescriptionInput.vue'
// import AiPromptExport from '@/components/AiPromptExport.vue'
import AiVersionSelector from '@/components/AiVersionSelector.vue'
import debounce from '@/utils/debounce'
import { mapState } from 'vuex'

export default {
  components: {
    AiDescriptionInput,
    AiVersionSelector,
    HelpDialogWorkflowAiVersion,
    HelpDialogWorkflowAiPrompt
    // AiPromptExport
  },

  computed: {
    ...mapState({
      workflow: state => state.workflow.workflow,
      requirementTypes: state => state.requirementTypes.requirementTypes
    })
  },

  data () {
    return {
      aiVersion: 0,
      createTypeOpen: false,
      createTypeFetching: false,
      validForm: true,
      isLoading: true,
      rules: {
        required: value => !!value || 'Required.'
      },
      saveAiDescriptionDebouncer: debounce(e => {
        this.saveAiDescription(e)
      }, 1000),
      aiModels: [
        { name: 'Qlerify', version: 5 },
        { name: 'OpenAI ChatGPT-4o', version: 6 },
        { name: 'OpenAI ChatGPT-4o-mini', version: 3 },
        { name: 'OpenAI ChatGPT-4', version: 4 }
      ]
    }
  },

  methods: {
    debouncedSaveAiDescription ({ description, skipDebounce }) {
      if (skipDebounce) {
        this.saveAiDescription(description)
      } else {
        this.saveAiDescriptionDebouncer(description)
      }
    },
    saveAiDescription (e) {
      workflowApi.updateWorkflowNoHistoryMutation(
        this.$route.params.projectId,
        {
          id: this.$route.params.id,
          expectedVersion: this.workflow.version,
          aiDescription: e
        }
      )
    },
    async createRequirementType () {
      let counter = 1
      while (this.requirementTypes.findIndex(rt => rt.title === `Card type ${counter}`) >= 0) {
        counter++
      }
      const title = `Card type ${counter}`
      const description = `Card type ${counter} description`
      const color = {
        red: 158,
        green: 158,
        blue: 158
      }
      const workflowId = this.$route.params.id
      this.createTypeFetching = true
      const input = {
        title,
        description,
        color,
        showInBacklog: true,
        triggerType: false,
        queryType: false,
        aggregateType: false,
        defaultType: false
      }
      await store.dispatch('requirementTypes/createRequirementType', { workflowId, input })
      this.createTypeOpen = false
      this.createTypeFetching = false
    }
  }
}
</script>

<style scoped>
.tab-content {
  height: 900px;
}

:deep(.v-select__menu-icon) {
  display: none !important;
}

.sortableRow > div:focus-within {
  outline: 2px solid #4d90fe;
}

.sortable-chosen {
  background: #eee;
}

.sortable-ghost {
  background: #E5E3E1;
}

.sortable-ghost > div {
  opacity: 0.01;
}

.p-3 {
  padding: 12px;
}

.gap-y-1 {
  row-gap: 8px;
}

#default-type {
  span {
    font-weight: 600;
  }
}
</style>
